import { render, staticRenderFns } from "./delivery-price-set-unset.vue?vue&type=template&id=115ae206"
import script from "./delivery-price-set-unset.vue?vue&type=script&lang=js"
export * from "./delivery-price-set-unset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports